// HOMEPAGE

export const HOMEPAGE_MAIN_BANNER =
  process.env.PUBLIC_URL + "/images/homepage-main-banner.jpg"

export const HOMEPAGE_SECOND_BANNER =
  process.env.PUBLIC_URL + "/images/homepage-second-banner.jpeg"

export const HOMEPAGE_CORP_SERVICE_BANNER =
  process.env.PUBLIC_URL + "/images/corporate-service.jpg"

export const HOMEPAGE_INVESTMENTS_BANNER =
  process.env.PUBLIC_URL + "/images/investments.jpg"

export const HOMEPAGE_INT_COMMERCE_BANNER =
  process.env.PUBLIC_URL + "/images/international-commerce.jpg"

export const HOMEPAGE_REAL_ESTATE_BANNER =
  process.env.PUBLIC_URL + "/images/real-estate.jpg"

export const HOMEPAGE_ACCOUNTING_SERVICE_BANNER =
  process.env.PUBLIC_URL + "/images/accounting.jpg"

export const HOMEPAGE_CONSULTANTS_SERVICE_BANNER =
  process.env.PUBLIC_URL + "/images/business-consultants.jpeg"

export const HOMEPAGE_DIGITAL_SERVICE_BANNER =
  process.env.PUBLIC_URL + "/images/digital-solutions.jpeg"

// ABOUT PAGE

export const COMPANY_CEO_AVATAR = ""

// CORPORATE SERVICE PROVIDER PAGE

export const CORP_SERVICE_PAGE_IMAGE_ONE =
  process.env.PUBLIC_URL + "/images/company-formation.jpg"

export const CORP_SERVICE_PAGE_IMAGE_TWO =
  process.env.PUBLIC_URL + "/images/nominee-services.jpg"

export const CORP_SERVICE_PAGE_IMAGE_THREE =
  process.env.PUBLIC_URL + "/images/trust-formation.jpg"

export const CORP_SERVICE_PAGE_IMAGE_FOUR =
  process.env.PUBLIC_URL + "/images/compliance-support.jpg"

export const CORP_SERVICE_PAGE_IMAGE_FIVE =
  process.env.PUBLIC_URL + "/images/secretarial-services.jpg"

// INVESTMENTS PAGE

export const INVESTMENTS_PAGE_IMAGE_ONE =
  process.env.PUBLIC_URL + "/images/healthcare.jpg"

export const INVESTMENTS_PAGE_IMAGE_TWO =
  process.env.PUBLIC_URL + "/images/agriculture.jpg"

export const INVESTMENTS_PAGE_IMAGE_THREE =
  process.env.PUBLIC_URL + "/images/oil-natural-gas.jpg"

export const INVESTMENTS_PAGE_IMAGE_FOUR =
  process.env.PUBLIC_URL + "/images/education.jpg"

export const INVESTMENTS_PAGE_IMAGE_FIVE =
  process.env.PUBLIC_URL + "/images/water-treatment.jpg"

export const INVESTMENTS_PAGE_IMAGE_SIX =
  process.env.PUBLIC_URL + "/images/sports.jpg"

export const INVESTMENTS_PAGE_IMAGE_SEVEN =
  process.env.PUBLIC_URL + "/images/energy.jpg"

export const INVESTMENTS_PAGE_IMAGE_EIGHT =
  process.env.PUBLIC_URL + "/images/retail-wholesale-trading.jpg"

export const INVESTMENTS_PAGE_IMAGE_NINE =
  process.env.PUBLIC_URL + "/images/tourism.jpg"

export const INVESTMENTS_PAGE_IMAGE_TEN =
  process.env.PUBLIC_URL + "/images/manufacturing.jpg"

export const INVESTMENTS_PAGE_IMAGE_ELEVEN =
  process.env.PUBLIC_URL + "/images/ecommerce.jpg"

export const INVESTMENTS_PAGE_IMAGE_TWELVE =
  process.env.PUBLIC_URL + "/images/digital-innovation.jpg"

// INTERNATIONAL COMMERCE PAGE

export const INT_COMMERCE_PAGE_IMAGE_ONE =
  process.env.PUBLIC_URL + "/images/agarwood.jpeg"

export const INT_COMMERCE_PAGE_IMAGE_TWO =
  process.env.PUBLIC_URL + "/images/copper.jpeg"

export const INT_COMMERCE_PAGE_IMAGE_THREE =
  process.env.PUBLIC_URL + "/images/aluminium.jpeg"

export const INT_COMMERCE_PAGE_IMAGE_FOUR =
  process.env.PUBLIC_URL + "/images/gold.jpeg"

export const INT_COMMERCE_PAGE_IMAGE_FIVE =
  process.env.PUBLIC_URL + "/images/steel.jpeg"

export const INT_COMMERCE_PAGE_IMAGE_SIX =
  process.env.PUBLIC_URL + "/images/clothing.jpeg"

// REAL ESTATE PAGE

export const REAL_ESTATE_PAGE_IMAGE_ONE =
  process.env.PUBLIC_URL + "/images/property-development.jpg"

export const REAL_ESTATE_PAGE_IMAGE_TWO =
  process.env.PUBLIC_URL + "/images/real-estate-investment.jpg"

export const REAL_ESTATE_PAGE_IMAGE_THREE =
  process.env.PUBLIC_URL + "/images/property-management.jpg"

export const REAL_ESTATE_PAGE_IMAGE_FOUR =
  process.env.PUBLIC_URL + "/images/real-estate-advisory.jpg"

export const REAL_ESTATE_PAGE_IMAGE_FIVE =
  process.env.PUBLIC_URL + "/images/joint-ventures-partnerships.jpg"

// ACCOUNTING_SERVICE & BOOKKEEPING PAGE

export const ACCOUNTING_SERVICE_PAGE_IMAGE_ONE =
  process.env.PUBLIC_URL + "/images/tax-registration.jpeg"

export const ACCOUNTING_SERVICE_PAGE_IMAGE_TWO =
  process.env.PUBLIC_URL + "/images/return-filing.jpg"

export const ACCOUNTING_SERVICE_PAGE_IMAGE_THREE =
  process.env.PUBLIC_URL + "/images/consultancy.jpeg"

export const ACCOUNTING_SERVICE_PAGE_IMAGE_FOUR =
  process.env.PUBLIC_URL + "/images/accounting-bookkeeping.jpeg"

// OVERSEAS BUSINESS CONSULTANT PAGE

export const CONSULTANTS_SERVICE_PAGE_IMAGE_ONE =
  process.env.PUBLIC_URL + "/images/entry-strategy.jpeg"

export const CONSULTANTS_SERVICE_PAGE_IMAGE_TWO =
  process.env.PUBLIC_URL + "/images/compliance-assistance.jpeg"

export const CONSULTANTS_SERVICE_PAGE_IMAGE_THREE =
  process.env.PUBLIC_URL + "/images/cultural-adaptation.jpeg"

export const CONSULTANTS_SERVICE_PAGE_IMAGE_FOUR =
  process.env.PUBLIC_URL + "/images/ongoing-support.jpeg"

// DIGITAL SOLUTION PAGE

export const DIGITAL_SERVICE_PAGE_IMAGE_ONE =
  process.env.PUBLIC_URL + "/images/web-development.jpeg"

export const DIGITAL_SERVICE_PAGE_IMAGE_TWO =
  process.env.PUBLIC_URL + "/images/app-development.jpeg"

export const DIGITAL_SERVICE_PAGE_IMAGE_THREE =
  process.env.PUBLIC_URL + "/images/digital-marketing.png"

export const DIGITAL_SERVICE_PAGE_IMAGE_FOUR =
  process.env.PUBLIC_URL + "/images/graphic-designing.jpeg"

// CONTACT PAGE

export const COMPANY_CONTACT_ADDRESS =
  "402, Al Moosa Tower 1, Sheikh Zayed Road, Dubai - UAE"

export const COMPANY_TIMINGS = "10:00 AM - 06:00 PM"

export const COMPANY_WORKING_DAYS = "Monday - Friday"

export const COMPANY_CONTACT_PHONE = "+971 042686404"

export const COMPANY_CONTACT_EMAIL = "info@morifar.com"

export const COMPANY_GOOGLE_MAPS =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.6055821658056!2d55.27799261284136!3d25.21652038305132!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f433f75dd237b%3A0xb2cee90bde173790!2sAl%20Moosa%20Tower%201!5e0!3m2!1sen!2sin!4v1767529650514!5m2!1sen!2sin"
